<template>
  <div class="toolbar-search">
    <!-- Desktop version -->
    <div class="hidden-sm-and-down search-wrapper">
        <!-- Barre de recherche -->
        <div class="search-bar-selected-wrapper">
          <v-text-field
            v-model="searchQuery"
            hide-details
            prepend-inner-icon="mdi-magnify"
            placeholder="Rechercher un magasin..."
            solo
            flat
            clearable
            @input="onSearchInput"
            @click="onSearchClick"
            @blur="onBlur"
            class="search-bar"
          >
            <template v-if="selectedEnseigne && selectedEnseigne.id" v-slot:append>
              <v-chip class="selected-customer-chip" color="secondary" text-color="white" label>
                <span>{{ selectedEnseigne.name }}</span>
                <v-btn icon small @click.stop="clearSelected" class="ml-1">
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </v-chip>
            </template>
          </v-text-field>
        </div>

      <!-- Résultats de recherche -->
      <v-card v-if="showResults && filteredResults.length > 0" class="search-results elevation-0">
        <v-list class="py-0">
          <v-list-item
            v-for="result in filteredResults.slice(0, 8)"
            :key="result.id"
            @mousedown.prevent="selectStore(result)"
            class="result-item"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ result.name }}
              </v-list-item-title>
              <v-list-item-subtitle class="mt-1">
                {{ result.enseigne }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon size="20" color="#8AC3D5">mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-divider v-if="filteredResults.length > 8" class="my-0"></v-divider>
        <div v-if="filteredResults.length > 8" class="pa-3 text-center text-caption grey--text">
          +{{ filteredResults.length - 8 }} résultat(s)
        </div>
      </v-card>
    </div>
    
    <!-- Mobile version -->
    <div class="hidden-md-and-up mobile-search-container">
      <!-- Bouton pour ouvrir la recherche -->
      <v-btn
        v-if="!showMobileSearch"
        fab
        small
        color="white"
        class="mobile-search-trigger"
        @click="showMobileSearch = true"
      >
        <v-icon color="primary">mdi-magnify</v-icon>
      </v-btn>
      
      <!-- Barre de recherche spotlight -->
      <v-expand-transition>
        <v-card v-if="showMobileSearch" class="mobile-search-spotlight elevation-8">
          <v-card-text class="pa-2">
            <v-text-field
              v-model="searchQuery"
              hide-details
              prepend-inner-icon="mdi-magnify"
              placeholder="Rechercher un magasin..."
              solo
              flat
              clearable
              autofocus
              @input="onSearchInput"
              @click="onSearchClick"
              class="mobile-search-field"
            >
              <template v-slot:append>
                <v-btn icon small @click="closeMobileSearch">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
            </v-text-field>
            
            <!-- Affichage de l'enseigne sélectionnée -->
            <div v-if="selectedEnseigne && selectedEnseigne.id" class="mobile-selected-chip">
              <v-chip color="secondary" text-color="white" label>
                <span>{{ selectedEnseigne.name }}</span>
                <v-btn icon small @click.stop="clearSelected" class="ml-1">
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </v-chip>
            </div>
            
            <!-- Résultats mobile -->
            <v-list v-if="showResults && filteredResults.length > 0" class="mt-2">
              <v-list-item
                v-for="result in filteredResults.slice(0, 5)"
                :key="result.id"
                @click="selectStoreMobile(result)"
                class="mobile-result-item"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ result.name }}</v-list-item-title>
                  <v-list-item-subtitle class="text-caption">{{ result.enseigne }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-expand-transition>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      searchQuery: '',
      showResults: false,
      showMobileSearch: false
    }
  },
  computed: {
    ...mapState({
      enseignes: state => state.enseignes.all,
      selectedEnseigne: state => state.enseignes.current
    }),
    filteredResults() {
      // Si pas de recherche, retourner tous les magasins
      if (!this.searchQuery || this.searchQuery.trim() === '') {
        return this.enseignes
      }
      
      // Filtrer par recherche
      const query = this.searchQuery.toLowerCase().trim()
      return this.enseignes.filter(e => 
        e.name.toLowerCase().includes(query) || 
        e.enseigne.toLowerCase().includes(query) ||
        (e.address && e.address.toLowerCase().includes(query))
      )
    }
  },
  methods:{
    selected(enseigne) {
      this.$nextTick(() => {
        this.$store.dispatch('setCurrentEnseigne', enseigne)
        if (enseigne && enseigne.latitude) {
          this.$store.dispatch('setZoomLevel', 10)
          this.$store.dispatch('setCenter', [Number(enseigne.latitude), Number(enseigne.longitude)])
          this.$store.dispatch('setZoom', true)
        }
      })
    },
    clearSelected() {
      // Lève la sélection et revient à la vue France entière
      this.$store.dispatch('deselectEnseigne')
    },
    zoom() {
      this.$store.dispatch('resetZoom')
    },
    onSearchInput() {
      this.showResults = this.searchQuery && this.searchQuery.trim() !== ''
    },
    onSearchClick() {
      // Afficher les résultats au clic, même sans recherche
      this.showResults = true
    },
    onBlur() {
      // Délai pour permettre le clic sur un résultat
      setTimeout(() => {
        this.showResults = false
      }, 200)
    },
    selectStore(store) {
      this.searchQuery = ''
      this.showResults = false
      this.selected(store)
    },
    selectStoreMobile(store) {
      this.searchQuery = ''
      this.showResults = false
      this.showMobileSearch = false
      this.selected(store)
    },
    closeMobileSearch() {
      this.showMobileSearch = false
      this.searchQuery = ''
      this.showResults = false
    }
  }
}

</script>
<style lang="scss" scoped>
.toolbar-search {
  width: 100%;
  min-width: 0;
  position: relative;
  z-index: 1500;
}

/* En barre compacte, la recherche se réduit à son bouton : elle ne doit pas
   revendiquer la largeur restante au détriment du switch de contexte */
@media (max-width: 959px) {
  .toolbar-search {
    width: auto;
    flex: 0 0 auto;
  }
}

.search-wrapper {
  position: relative;
  width: 100%;
  min-width: 0;
  pointer-events: auto;
}

.search-bar {
  width: 100%;
  min-width: 0;
  pointer-events: auto;
  
  ::v-deep .v-input__control {
    min-height: 50px !important;
  }
  
  ::v-deep .v-input__slot {
    background: white !important;
    border-radius: 25px !important;
    padding: 0 20px !important;
    border: 2px solid #e0e0e0 !important;
    transition: all 0.2s ease;
    box-shadow: 0 2px 4px rgba(0,0,0,0.08) !important;
  }
  
  ::v-deep .v-input__slot:hover {
    border-color: #8AC3D5 !important;
    box-shadow: 0 4px 8px rgba(138, 195, 213, 0.3) !important;
  }
  
  ::v-deep .v-input--is-focused .v-input__slot {
    border-color: #376374 !important;
    background: white !important;
    box-shadow: 0 4px 12px rgba(55, 99, 116, 0.2) !important;
  }
  
  ::v-deep input {
    font-size: 15px !important;
    color: #212121 !important;
    background: transparent !important;
  }
  
  ::v-deep input::placeholder {
    color: #9e9e9e !important;
  }
  
  ::v-deep .v-input__prepend-inner {
    margin-top: 0 !important;
    margin-right: 12px !important;
    align-self: center !important;
  }
  
  ::v-deep .v-input__append-inner {
    margin-top: 0 !important;
    align-self: center !important;
  }
  
  ::v-deep .v-icon {
    color: #376374 !important;
  }
}

.search-results {
  position: fixed;
  top: 85px;
  left: 50%;
  transform: translateX(-50%);
  width: 600px;
  max-width: 90vw;
  border-radius: 12px !important;
  max-height: 400px;
  overflow-y: auto;
  overscroll-behavior: contain;
  z-index: 2001 !important;
  background: white !important;
  border: 1px solid #e0e0e0;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
}

.result-item {
  transition: all 0.2s ease;
  background: white !important;
  padding: 12px 16px !important;
  
  &:hover {
    background-color: #f8fbfc !important;
  }
  
  ::v-deep .v-list-item__content {
    padding: 0 !important;
  }
  
  ::v-deep .v-list-item__action {
    margin: 0 0 0 16px !important;
    align-self: center !important;
  }
  
  ::v-deep .v-list-item__title {
    color: #212121 !important;
    font-size: 15px !important;
    font-weight: 500 !important;
  }
  
  ::v-deep .v-list-item__subtitle {
    color: #757575 !important;
    font-size: 13px !important;
  }
}

/* Mobile Styles */
.mobile-search-container {
  position: relative;
  z-index: 1600;
}

.mobile-search-trigger {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important;
  position: relative;
  z-index: 1600;
}

.mobile-search-spotlight {
  position: fixed;
  top: 70px;
  left: 8px;
  right: 8px;
  max-height: 70vh;
  max-height: 70dvh;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  border-radius: 12px !important;
  z-index: 2000;
}

.mobile-search-field {
  ::v-deep .v-input__slot {
    background: white !important;
    border-radius: 8px !important;
  }
  
  ::v-deep input {
    color: #212121 !important;
  }
}

.mobile-result-item {
  border-bottom: 1px solid #f5f5f5;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:active {
    background-color: #f8fbfc !important;
  }
}

.mobile-selected-chip {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 8px 0 0 0;
    padding-left: 2px;
  }
</style>
